import { SelectOption } from 'global';
import { TextFieldProps } from '@mui/material';
import { AutocompleteProps } from '@mui/material/Autocomplete';
import { convertEnumToSelectOptions } from 'utils/selectOptionsHelper';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';

import {
  CANADA_REGION_CODES,
  EQUIPMENT_CONDITION,
  FINANCING_TYPE,
  LEGAL_STRUCTURE,
  US_REGION_CODES,
} from '@trnsact/trnsact-shared-types';
import { convertFactToSelectOptions } from '../lib';

export const factNamesNumeric = convertFactToSelectOptions(FACT_NAMES_NUMERIC);
export const factNamesBoolean = convertFactToSelectOptions(FACT_NAMES_BOOLEAN);
export const factNamesString = convertFactToSelectOptions(FACT_NAMES_STRING);

export const allFacts = [...factNamesNumeric, ...factNamesString, ...factNamesBoolean];

const equipmentConditionOptions = convertEnumToSelectOptions(EQUIPMENT_CONDITION);
const financingTypeOptions = convertEnumToSelectOptions(FINANCING_TYPE, { useKeyAsValue: true });
const legalStructureOptions = convertEnumToSelectOptions(LEGAL_STRUCTURE);
const canadaRegionOptions = convertEnumToSelectOptions(CANADA_REGION_CODES);
const usRegionOptions = convertEnumToSelectOptions(US_REGION_CODES);

export const autocompletePropsByType: Partial<
  Record<
    FACT_NAMES_STRING,
    Omit<AutocompleteProps<SelectOption, true, false, false>, 'renderInput'> & {
      textFieldProps?: Partial<TextFieldProps>;
    }
  >
> = {
  [FACT_NAMES_STRING.EQUIPMENT_CONDITION]: {
    textFieldProps: {
      required: true,
      label: 'Select the Equipment Condition',
    },
    options: equipmentConditionOptions,
  },
  [FACT_NAMES_STRING.FINANCING_TYPE]: {
    textFieldProps: {
      required: true,
      label: 'Select a Financing Type',
    },
    options: financingTypeOptions,
  },
  [FACT_NAMES_STRING.LEGAL_STRUCTURE]: {
    textFieldProps: {
      required: true,
      label: 'Select a Legal Structure',
    },
    options: legalStructureOptions,
  },
  [FACT_NAMES_STRING.CANADA_REGION]: {
    textFieldProps: {
      required: true,
      label: 'Select a Region',
    },
    options: canadaRegionOptions,
  },
  [FACT_NAMES_STRING.USA_STATE]: {
    textFieldProps: {
      required: true,
      label: 'Select a State',
    },
    options: usRegionOptions,
  },
  [FACT_NAMES_STRING.DEALERS]: {
    textFieldProps: {
      required: true,
      label: 'Select Dealers',
    },
    options: [], // Will be populated dynamically
  },
};

export const booleanOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
